import React from 'react';
import { OperationEsrrQuestions, EsrrContextType } from '../../../../services/types/Esrr';

const Context = React.createContext<EsrrContextType>({
  questions: [] as OperationEsrrQuestions[],
  loadingQuestions: false,
});

export default Context;
